module.exports = __webpack_public_path__ + "static/media/v-hackathon.8d525bbd.png";